import { Link } from 'react-router';
import { Meta } from '@/components/Meta';

export function NotFoundPage() {
  return (
    <>
      <Meta title="404 — Rachele Dolcezze" />
      <div className="u-container flex min-h-screen flex-col items-center justify-center text-center">
        <p className="font-display text-[28vw] leading-none md:text-[14vw]">404</p>
        <p className="mt-6 max-w-sm text-ink-soft">La pagina che cerchi non esiste… ma i dolci sì.</p>
        <Link
          to="/"
          className="mt-8 rounded-full border border-sage-deep px-7 py-3 text-xs uppercase tracking-[0.2em] text-sage-deep transition-colors hover:bg-sage-deep hover:text-cream"
        >
          Torna alla home
        </Link>
      </div>
    </>
  );
}
